import { render } from "./Imagem.vue?vue&type=template&id=a3cdc1ae&scoped=true"
import script from "./Imagem.vue?vue&type=script&lang=js"
export * from "./Imagem.vue?vue&type=script&lang=js"

import "./Imagem.vue?vue&type=style&index=0&id=a3cdc1ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3cdc1ae"]])

export default __exports__